import DriveInfo from 'modules/DriveInfo/index'
import selectors from 'modules/DriveInfo/selectors'
import { connect } from 'react-redux'
import {
  getStudentDriveListData,
  getViewDriveInfo,
} from 'modules/DriveInfo/action'

import { getSingleStudentData } from 'modules/Students/actions'
const mapStateToProps = state => ({
  UserDriveList: selectors.getStudentsListData(state),
  ViewDriveList: selectors.getViewDriveInfoData(state),
  singleStudentData: selectors.getSingleStudentData(state),
})

const mapDispatchToProps = {
  getStudentDriveListData,
  getViewDriveInfo,
  getSingleStudentData,
}

export default connect(mapStateToProps, mapDispatchToProps)(DriveInfo)
